import { FC } from "react";
import { motion } from "framer-motion";

import "./IOSInstall.css";

import { PrimaryButton } from "./PrimaryLink";
import { IconButton } from "./IconButton";
import { CheckIcon, CloseIcon } from "./Icons";

interface IOSInstallProps {
  isVisible?: boolean;
  onClose: () => void;
}

export const IOSInstall: FC<IOSInstallProps> = ({
  isVisible,
  onClose
}) => (
  <motion.div
    className="ios-install"
    initial={{
      y: "100%",
      opacity: 0
    }}
    animate={{
      y: isVisible ? 0 : "100%",
      opacity: isVisible ? 1 : 0
    }}
    transition={{
      duration: 0.5,
      ease: [0.19, 1, 0.22, 1]
    }}
  >
    <div className="ios-install__content">
      <div className="ios-install__header">
        <IconButton onClick={onClose} className="ios-install__close-icon">
          <CloseIcon />
        </IconButton>
      </div>
      <div className="ios-install__steps">
        <div className="ios-install__step">
          <p>1. Press the share button</p>
          <img src="/images/install_step1.png" alt="Press the share button" />
        </div>
        <div className="ios-install__step">
          <p>2. Select &quot;Add to Home Screen&quot;</p>
          <img src="/images/install_step2.png" alt="Select Add to Home Screen" />
        </div>
        <div className="ios-install__step">
          <p>3. Press the &quot;Add&quot; button</p>
          <img src="/images/install_step3.png" alt="Press the Add button" />
        </div>
      </div>
      <div className="ios-install__footer">
        <PrimaryButton onClick={onClose}>
          <CheckIcon />
        </PrimaryButton>
      </div>
    </div>
  </motion.div>
);